import type { Middleware } from "openapi-fetch";

export function throwOnErrorResponse(): Middleware {
    return {
        async onResponse({ response }) {
            if (response.ok) {
                return undefined;
            }

            const body = await response
                .clone()
                .json()
                .catch(() => undefined);
            const detail = body?.detail ?? body?.title ?? body?.message;
            const error = new Error(
                `API error ${response.status}: ${detail ?? response.statusText ?? "Unknown error"}`
            );

            throw Object.assign(error, body, { status: response.status, message: error.message, detail });
        }
    };
}
